<script setup>
  import { defineProps, onMounted, ref, defineEmits, watch, nextTick } from "vue";
  import { useQueryOrderDetail/*, useCanelOrder*/ } from '@/hooks/shopify-hooks/useShopifyUtils';
  import { _CSR_ACCESS_TOKEN, _CSR_IS_B2b, _CSP_ORDER_STATUS } from '@/const/shopifyConst.js';
  import { handleCopy,getJumpLink } from "@/utils/common.js"
  import Price from '@/components/three-in-one/toshiba/price/v1/ShopifyPrice.vue';
  import OrderStatus from '@/components/three-in-one/toshiba/shopify-component/account/components/OrderStatus.vue';
  import Record from "@/components/three-in-one/toshiba/shopify-component/add-to-cart/Index.vue"
  import Dayjs from "dayjs";
  import { debounce, cloneDeep } from "lodash-es";
  import { useGetStorage } from '@/hooks/common/useStorage';
  import useHomeProperties from "@/hooks/common/useHomeProperties";
  import { isPhonePortrait } from "@/hooks/common/useUtils";
  import { useAEMFetch } from "@/hooks/common/fetch/useFetch";
  import { useCsrCmpState } from "@/hooks/common/useCsrCmpState";
  import { useGetProductIdNumber } from '@/hooks/shopify-hooks/useShopifyUtils';
  import { v4 as uuidv4 } from 'uuid';
  import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';
const {  c4aOAuth2State } = shopifyConst;
const c4aOAuth2StateNew = c4aOAuth2State === 'true' ? true : false;

  const props = defineProps({
    stateKey: {
      type: String,
      default: "",
    },
    config: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    },
  });
  // eslint-disable-next-line
   const {enableBazaarvoice='N'} = useHomeProperties();
  const loading = ref(true)
  const emit = defineEmits(["handleOrderListJumpDetail"])
  const orderList = ref([])
  const orderListCopy = ref([])
  const orderListConfig = ref({})
  // const { accessToken } = JSON.parse(localStorage.getItem(_CSR_ACCESS_TOKEN));
  // const isB2b = localStorage.getItem(_CSR_IS_B2b) === 'true';
  const { accessToken } = useGetStorage(_CSR_ACCESS_TOKEN);
  const isB2b = useGetStorage(_CSR_IS_B2b) === true;
  const emptyTxt = ref("");
  const isSeach = ref(false);
  const customerEmail = ref("");
  const searchResultCount = ref(0);
  const showSearchResult = ref(false);
  const myOrderRef = ref(null);

// eslint-disable-next-line
const { state } = useCsrCmpState({
  stateKey: props.stateKey,
});
const { urlPrefix } = state.conf;

  // 处理订单id
  function sanitizeOrderId(orderId, isB2B) {
    const queryParamaterIndex = orderId.indexOf('?')
    return orderId.substring(20, !isB2B ? queryParamaterIndex : undefined);
  }
  // 根据订单信息确定订单状态
  const determineOrderStatus = (cancelReason, fulfillment_status, shipment_status) => {
    if (cancelReason) {
      return "cancelled"
    } else if (shipment_status === 'delivered') {
      return "delivered"
    } else {
      return fulfillment_status || "progress"
    }
  }

  // 获取订单状态和物流编号信息
  const getOrderStatus = async (item) => {
    try {
      const { id, cancelReason } = item
      const newId = sanitizeOrderId(id, c4aOAuth2StateNew ? true : isB2b)
      // 获取订单详情
      const res = await useQueryOrderDetail(accessToken, customerEmail.value, newId, isB2b);
      if (res) {
        const { fulfillment_status = "", fulfillments = [] } = res
        const firstFulfillment = fulfillments?.[0] || {}
        const { tracking_number = "", shipment_status = "" } = firstFulfillment
        // 订单状态
        item.orderStatus = determineOrderStatus(cancelReason, fulfillment_status, shipment_status)
        // 物流编号
        item.logisticsCode = tracking_number
      }
    } catch (error) {
      loading.value = false
    }
  }

  // 将数组每10个分成一组
function chunkArrayByTen(arr) {
    const res = [];
    for (let i = 0; i < arr.length; i += 10) {
      res.push(arr.slice(i, i + 10).map(item => useGetProductIdNumber(item?.shopifyId)));
    }
    return res;
}

  //  获取存档信息
  const fetchArchiveInfo = async (orderList) => {
    const shopifyIdParamList = chunkArrayByTen(orderList);
    const fetchList = []
    try {
      shopifyIdParamList.forEach(shopifyIdList => {
        const fetch = useAEMFetch(`${urlPrefix}.productdata.json?shopifyId=${encodeURIComponent(JSON.stringify(shopifyIdList))}`).get().json();
        fetchList.push(fetch)
      });
      const res = await Promise.all(fetchList);
      const productList = res.reduce((pre, cur) => {
        if (cur?.data?.value?.length) {
          return pre.concat(cur.data.value);
        }
        return pre;
      }, []);
      orderList.forEach(order => {
        productList.forEach(sku => {
          if (useGetProductIdNumber(order.shopifyId) === useGetProductIdNumber(sku.product.shopifyId)) {
            const { archiveHyperLink, link, archive, productModelNumber, productName } = sku?.product || {};
            order.productName = productName;
            order.archiveHyperLink = archiveHyperLink;
            order.link = link;
            order.archive = archive;
            // 若shopify没有配sku，取AEM的modelNumber
            order.sku = order.sku ?? productModelNumber;
          }
        });
        // 前端生成唯一id作为v-for的key
        order.uniqueId = uuidv4();
      });
    } 
    catch (error) {
      console.error(error); // 使用 console.error 代替 console.log
      throw error; // 抛出异常，让调用者处理
    }

  };

  // 过滤属性
  const filterAttributes = (attributesObj) => {
    const newObj = {};
    for (const key in attributesObj) {
      if (!['_productLink', '_productImage', '_productModel', '_productName', 'productImage', 'productName'].includes(key)) {
        newObj[key] = attributesObj[key];
      }
    }
    return newObj;
  };
  const handleCustomAttributes = (customAttributes, attributesObj) => {
    customAttributes.forEach(attr => {

      if (attr.key === 'Color') {
        attributesObj.colorObj.value = attr.value
      } else if (attr.key === 'ColorName') {
        attributesObj.colorObj.label = attr.value
      }
      else {
        attributesObj[attr.key] = attr.value
      }
    })
  }
  // 收货地址拼接处理
  const handleAdress = (shippingAddress) => {
    const addressAry = []
    if(shippingAddress && Object.keys(shippingAddress).length) {
      addressAry.push(shippingAddress.address1);
      addressAry.push(shippingAddress.address2);
      addressAry.push(shippingAddress.city);
      addressAry.push(shippingAddress.provinceCode || shippingAddress.zoneCode);
      addressAry.push(shippingAddress.zip);
    }
    return addressAry.filter(item=> item).join(" ") || ""
  }
  // 拆分数据格式处理函数
  const handleFormatObj = (item) => {
    //eslint-disable-next-line
    return item.lineItems.edges.map(it => {
      const { customAttributes, discountedTotalPrice,currentTotalPrice, quantity, title, variant, sku } = it.node
      const attributesObj = {
        _productLink: "",
        _productImage: "",
        productImage: "",
        _productModel: "",
        colorObj: {
          label: "",
          value: ""
        }
      }

      handleCustomAttributes(customAttributes, attributesObj)

      const shippingAddress = handleAdress(item?.shippingAddress)
      const addressee = item?.shippingAddress?.name
      const currentTotalTax = item?.currentTotalTax?.amount
      const totalPrice = item?.totalPrice?.amount
      const currencyCode = item?.totalPrice?.currencyCode
      const totalShippingPrice = item?.totalShippingPrice?.amount
      const id = item?.id
      // const email = item?.email
      const successfulFulfillments = item?.successfulFulfillments
      const cancelReason = item?.cancelReason
      const financialStatus = item?.financialStatus
      let successfulFulfillmentsUrl = ""
      if (item?.successfulFulfillments && item?.successfulFulfillments.length && item?.successfulFulfillments[0]?.trackingInfo.length) {
        successfulFulfillmentsUrl = item?.successfulFulfillments[0]?.trackingInfo[0]?.url
      }
      const logoDom = document.querySelectorAll(".tsws-header-v1_inner-wrapper-logo")
      if (!attributesObj._productLink && logoDom && logoDom?.length) {
        const logHref = logoDom[0].getAttribute('href')
        const notFountUrl = logHref.split('.html');
        if (notFountUrl && notFountUrl?.length) {
          attributesObj._productLink = notFountUrl[0] + "/error-page/404.html"
        }
      }
      const obj = {
        id,
        originCustomAttributes: customAttributes,
        customAttributes: { ...filterAttributes(attributesObj) },
        discountedTotalPrice: isB2b || c4aOAuth2StateNew  ? currentTotalPrice?.amount : discountedTotalPrice?.amount,
        quantity,
        title,
        titleLink: attributesObj._productLink,
        productImage: attributesObj._productImage || attributesObj.productImage,
        sku: variant?.sku || attributesObj._productModel || sku,
        shopifyId: variant?.product?.id,
        variant,
        orderNumber: item?.orderNumber,
        processedAt: item?.processedAt && new Dayjs(item?.processedAt).format("YYYY-MM-DD"),
        shippingAddress,
        logisticsCode: item.logisticsCode,
        orderStatus: item.orderStatus || "",
        currentTotalTax: currentTotalTax,
        totalPrice: totalPrice,
        addressee,
        successfulFulfillmentsUrl,
        successfulFulfillments,
        cancelReason,
        financialStatus,
        totalShippingPrice,
        currencyCode,
      }
      return obj

    })
  }

  // 处理数据格式
  const handleOrderDataFormat = async (data) => {
    console.log(data, 'dataljlkjl');

    loading.value = true
    const tempAry1 = data.map(item => {
      return item.node
    })

    const promises = tempAry1.map(item => {
      return getOrderStatus(item)
    })

    await Promise.all(promises)
    console.log(tempAry1, 'tempAry1');

    // 处理里面的lineItems
    tempAry1.forEach(item => {
      item.orderNumber = item.orderNumber || item.number
      const tempAry2 = handleFormatObj(item)
      orderList.value.push(...tempAry2)
    });

    if (orderList.value.length > 0) {
      const promisesTwo = fetchArchiveInfo(orderList.value);

      try {
        await promisesTwo;
      } catch (error) {
        console.error(error);
      }
    } else {
      console.log('orderList.value is empty');
    }

    
    console.log('orderList.value: ', orderList.value);
    orderListCopy.value = cloneDeep(orderList.value);
    loading.value = false;
    setAddToCartProperty();
  }
  watch(() => props.customer, (customerData) => {
    console.log(customerData, 'customerData');
    customerEmail.value = customerData?.email
    const tempAry = customerData?.orders?.edges || []
    emptyTxt.value = props.config?.orderList?.defaultDescription
    isSeach.value = false
    handleOrderDataFormat(tempAry)
  }, { immediate: true })
  // 点击详情按钮
  const handleDetail = (item) => {
    const orderAry = orderListCopy.value.filter(it => {
      return it.orderNumber === item.orderNumber
    })
    console.log('handleDetail',orderListCopy,item,orderAry)
    emit('handleOrderListJumpDetail', orderAry)
  }
  onMounted(async () => {
    const { orderList: listconfig = {}, cancelButton, backButton, conpySuccessHint, orderStatusLabel = {} } = props.config || {}
    orderListConfig.value = { ...listconfig, cancelButton, backButton, conpySuccessHint, orderStatusLabel }
  });

  // 处理搜索
  const handleSearchOrder = debounce((event) => {
    const searchText = event.target.value
    // 去空格和转小写
    const formatStr = (str) => {
      if (!str) { return ''; }
      return String(str).replace(/\s+/g, '').toLowerCase();
    }
    const newStr = formatStr(searchText);
    if (newStr) {
      showSearchResult.value = true;
      // 过滤条件字段：orderNumber/totalPrice/shippingAddress/title/sku
      const filterConditions = ['orderNumber', 'totalPrice', 'shippingAddress', 'title', 'sku']
      orderList.value = orderListCopy.value.filter(item => {
        return filterConditions.some(key => {
          return formatStr(item[key]).includes(newStr);
        });
      })
      if (!orderList.value.length) {
        emptyTxt.value = orderListConfig.value?.noResultPrompt || "No order found"
        isSeach.value = true
      }
      searchResultCount.value = orderList.value.length;
    } else {
      //恢复全部数据
      showSearchResult.value = false;
      orderList.value = cloneDeep(orderListCopy.value);
    }

  }, 500)
  // 处理消息
  // const handleCancel = async (item) => {
  //   const { id } = item
  //   const newId = sanitizeOrderId(id, isB2b)
  //   // 获取订单详情
  //   loading.value = true
  //   const res = await useCanelOrder(accessToken, customerEmail.value, newId, isB2b);
  //   loading.value = false
  //   if (res) {
  //     window.igws.$toast.open({
  //       status: "success",
  //       text: "取消成功",
  //     });
  //     emit('update');
  //   } else {
  //     window.igws.$toast.open({
  //       status: "error",
  //       text: "取消失败",
  //     });
  //   }

  // }
  // 点击标题跳转
  const handleJump = (item) => {
    const { titleLink, archiveHyperLink, link } = item;
    if (archiveHyperLink) {
      return location.href = getJumpLink(item.archiveHyperLink);
    }
    if(link) {
      return location.href = getJumpLink(item.link);
    }
    if (titleLink) {
      location.href = getJumpLink(item.titleLink);
    }
  }

  // 设置addToCart按钮index属性，用于GA
const setAddToCartProperty = () => {
  nextTick(() => {
    $(myOrderRef.value).find('.csr-my-order__item').each((index, item) => {
      $(item).find('.csr-cp-cart a').attr('data-index', index);
    });
  });
}
  
</script>

<template>
  <div ref="myOrderRef" class="csr-account-my-order csr-my-order" v-Mdloading="loading">
  <div v-if="orderList.length || isSeach" class="flex csr-my-order__search">
    <div class="csr-my-order__search-content">
      <svg class="csr-my-order__search-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="20" height="20" viewBox="0 0 20 20"><g><g /><g><path d="M17.299534375,17.318199237060547Q17.431934375,17.186499237060545,17.431934375,17.000299237060545Q17.431934375,16.813999237060546,17.299534375,16.682299237060548L14.577134375,13.973799237060547L14.613434375,13.938399237060548Q16.616434375,11.984619237060548,16.616434375,9.184979237060546Q16.616434375,6.436649237060546,14.675834375,4.493309237060547Q12.735254375,2.549999237060547,9.990854375,2.549999237060547Q7.246444374999999,2.549999237060547,5.305854375,4.493309237060547Q3.365234375,6.436649237060546,3.365234375,9.184979237060546Q3.365234375,11.933269237060546,5.305854375,13.876699237060548Q7.246454375,15.819999237060546,9.990854375,15.819999237060546Q12.122254375,15.819999237060546,13.848434375,14.580099237060546L13.882834375,14.555399237060547L16.659734375,17.318199237060547Q16.979634375,17.636499237060548,17.299534375,17.318199237060547ZM5.943174375,13.238299237060547Q4.266618375,11.559329237060547,4.266617375,9.184979237060546Q4.266618375,6.810619237060547,5.943174375,5.131709237060547Q7.619764375,3.452756237060547,9.990854375,3.452756237060547Q12.361934375,3.452754237060547,14.038534375,5.131709237060547Q15.715134375,6.810639237060547,15.715134375,9.184979237060546Q15.715134375,11.559329237060547,14.038534375,13.238299237060547Q12.361944375,14.917299237060547,9.990854375,14.917299237060547Q7.619764375,14.917299237060547,5.943174375,13.238299237060547Z" fill-rule="evenodd" fill="#7A7A7A" fill-opacity="1" /></g></g></svg>
      <input class="csr-my-order__search__input" :placeholder="orderListConfig.searchLabel"
        @input="handleSearchOrder" />
    </div>
  </div>
  <div v-if="showSearchResult" class="csr-my-order__search-result">
    <span class="csr-my-order__search-result-value">{{ searchResultCount }}&nbsp;</span>
    <span class="csr-my-order__search-result-label">{{ orderListConfig.searchResult }}</span>
  </div>  
    <template v-if="orderList.length">
      <div class="csr-my-order__content">
        <div :class="['csr-my-order__item']" v-for="item in orderList" :key="item.uniqueId">
          <img :src="item.productImage" class="csr-my-order__item__image" :alt="item.title" />
          <div class="csr-my-order__item__info-box">
            <div class="csr-my-order__item__info-box-content">
              <div class="csr-my-order__item__info">
                <span @click="handleJump(item)" class="csr-my-order__item__name">{{ item.title }}</span>
                <div class="csr-my-order__item__line csr-my-order__item__model-num-color">
                  <div class="csr-my-order__item__sku csr-my-order__item__label">{{ item.sku }}</div>
                  <div class="csr-my-order__item__detail-list-box"
                    v-if="Object.keys(item.customAttributes).includes('colorObj')&&Object.keys(item.customAttributes).length>0">
                    <div :class="[
                      'csr-my-order__item__detail',
                      ((['colorObj'].includes(attrKey) && !item.customAttributes.colorObj.value) ||
                      (!['colorObj'].includes(attrKey) && !item.customAttributes[attrKey])) && 'empty'
                      ]"
                       v-for="(attrVal, attrKey) in item.customAttributes" :key="attrKey">
                      <div class="csr-my-order__item__detail-color"
                        v-if="(['colorObj'].includes(attrKey)&&item.customAttributes.colorObj.value) || !(['colorObj'].includes(attrKey))">
                        <template v-if="['colorObj'].includes(attrKey)">
                          <template v-if="attrVal.value">
                            <span>{{ item.customAttributes.colorObj.label }}</span>
                          </template>
                        </template>
                        <span v-else>{{ attrVal }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex csr-my-order__item__line">
                  <div class="csr-my-order__item__sku csr-my-order__item__label">{{ orderListConfig.orderNumberLabel }}
                  </div>
                  <div class="csr-my-order__item__value">{{ item.orderNumber }}</div>
                </div>
                <div class="flex csr-my-order__item__line csr-my-order__item__date csr-my-order__item__mb-hidden">
                  <div class="csr-my-order__item__sku csr-my-order__item__label">{{ orderListConfig.orderDateLabel }}
                  </div>
                  <div class="csr-my-order__item__value">{{ item.processedAt }}</div>
                </div>
                <div v-if="item.logisticsCode"
                  class="flex csr-my-order__item__line csr-my-order__item__date csr-my-order__item__mb-hidden">
                  <div class="csr-my-order__item__sku csr-my-order__item__label">{{ orderListConfig.logisticsCodeLabel
                    }}
                  </div>
                  <div class="csr-my-order__item__value">
                    <span>{{ item.logisticsCode }}</span>
                    <img @click="handleCopy(item.logisticsCode,orderListConfig.conpySuccessHint)"
                      class="csr-my-order__copy-image lazyload" src="@/assets/images/toshiba/copy.png" />
                  </div>
                </div>
                <div class="flex csr-my-order__item__line csr-my-order__item__date csr-my-order__item__mb-hidden">
                  <div class="csr-my-order__item__sku csr-my-order__item__label">{{
                    orderListConfig.deliveredAddressLabel
                    }}
                  </div>
                  <div class="csr-my-order__item__value">{{ item.shippingAddress }}</div>
                </div>
              </div>
              <div class="csr-my-order__item__part3">
                <div class="csr-my-order__item__price">
                  <Price :variant="{'price': { amount: item.discountedTotalPrice, currencyCode: item?.currencyCode } }" />
                </div>
                <div v-if="isPhonePortrait()" class="csr-my-order__item__num">{{ `x${item.quantity}` }}</div>
                <OrderStatus
                  v-if="item.orderStatus"
                  :order-status="item.orderStatus"
                  :label="orderListConfig.orderStatusLabel?.[item.orderStatus]">
                </OrderStatus>
              <!-- <OrderStatus :order-status="'delivered'" :label="'delivered'"></OrderStatus> -->
              </div>
            </div>
            <div class="csr-my-order__item__btn-stauts">
              <div v-if="!isPhonePortrait()" class="csr-my-order__item__num">{{ `x${item.quantity}` }}</div>
              <div class="csr-my-order__item__btn-group">
                <a v-if="item.successfulFulfillmentsUrl && item.orderStatus == _CSP_ORDER_STATUS._FULFILLED"
                  :href="item.successfulFulfillmentsUrl"
                  class="csr-my-order__btn">{{ orderListConfig.trackButton
                  }}</a>
                <Record
                  v-if="!item.archive && item.shopifyId && [_CSP_ORDER_STATUS._DELIVERED, _CSP_ORDER_STATUS._CANCELLED].includes(item.orderStatus)"
                  :state-key="stateKey"
                  :dataset="{ 'buttonLabel': orderListConfig.reorderButton, className: 'csr-my-order__btn'}"
                  :recordVariants="{ shopifyId: item.shopifyId, customAttributes: item.originCustomAttributes }"
                  :skuInfo="{
                    product: {
                      shopifyId: item.variant?.product?.id,
                      productModelNumber: item.sku,
                      productName: item.productName,
                    }
                  }" />
                  <!-- todo 取消订单逻辑还没梳理完 -->
                <!-- <button
                  v-if="!item.successfulFulfillments.length && !item.cancelReason && item.financialStatus === 'AUTHORIZED'"
                  @click="handleCancel(item)" class="csr-my-order__btn">{{
                  orderListConfig.cancelButton }}</button> -->
                <button @click="handleDetail(item)" class="csr-my-order__btn">{{
                  orderListConfig.detailButton }}</button>
                  <!-- <div v-if="enableBazaarvoice === 'Y' && item.sku && (item.orderStatus == _CSP_ORDER_STATUS._DELIVERED)"
                  class="bv-rating csr-my-order__btn"
                  data-bv-show="rating_summary" :data-bv-product-id="item.sku"></div> -->
              </div>
            </div>
          </div>
        </div>



      </div>
    </template>
    <template v-if="!loading && !orderList.length">
    <div class="csr-my-order__empty">
        <div class="csr-my-order__empty-box">
          <img class="csr-my-order__empty-image lazyload" src="@/assets/images/toshiba/empty.png" />
          <div class="csr-my-order__empty-txt">{{ emptyTxt }}</div>
        </div>
        <a :href="orderListConfig.defaultButtonLink" class="csr-my-order__empty-btn">{{ orderListConfig.defaultButton }}</a>
        </div>
      </template>
  </div>
</template>